import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function NEDAlertDialog({title, message,inOpen,setInOpen}) {
  //const [open, setOpen] = React.useState(inOpen);

  const handleClose = () => {
    setInOpen(false);    
  };

  return (
    <div>
     
      <Dialog
        open={inOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>         
          <Button onClick={handleClose} color="primary">
            Ok
          </Button> 
        </DialogActions>
      </Dialog>
    </div>
  );
}
